import { render, staticRenderFns } from "./ChangeContractDialog.vue?vue&type=template&id=72c2d4e9&scoped=true&"
import script from "./ChangeContractDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeContractDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeContractDialog.vue?vue&type=style&index=0&id=72c2d4e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2d4e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VRow,VSimpleTable})
